import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { GlobalSettings } from '../../api/models/GlobalSettings';
import { Storage } from '@lightningjs/sdk';
import { SELECTED_LANGUAGE_KEY } from './PlayerSettingsManager';
import { IStreamManifestResponseV3 } from '../../api/models/AndromeTV.types';
import { Backend } from '../../api/Backend';

export class PlayerUtil {
  static getInitialBitrate(globalSettings: GlobalSettings): number {
    const bitrate = 3000000;
    if (screen.height > 2000) {
      return globalSettings.numberValue(GlobalSettingsKeys.playerInitialBitrate4K) || bitrate;
    } else {
      return globalSettings.numberValue(GlobalSettingsKeys.playerInitialBitrate) || bitrate;
    }
  }

  static getInitialAudioLanguage(backend: Backend, manifest: IStreamManifestResponseV3) {
    let initialLanguage = '';
    const storedLang = Storage.get(SELECTED_LANGUAGE_KEY);
    if (manifest.playerPolicy?.hideAudioSelection) {
      // audio hidden so use no preferred audio track
      initialLanguage = '';
    } else if (storedLang) {
      initialLanguage = storedLang;
    } else {
      // take locale
      initialLanguage = backend.locale.slice(0, 2);
    }
    return initialLanguage;
  }
}
